export default __webpack_public_path__ + "static/media/arrowDownFrequently.0e85144d.svg";